import { render, staticRenderFns } from "./OutrosPacientesColetaDom.vue?vue&type=template&id=a3b06742&"
import script from "./OutrosPacientesColetaDom.vue?vue&type=script&lang=js&"
export * from "./OutrosPacientesColetaDom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports